import {makeStyles} from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        '&.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
            border: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        '&>.MuiDataGrid-main': {
            '&>.MuiDataGrid-columnHeaders': {
                borderBottom: 'none',
            },
            '& div div div div >.MuiDataGrid-cell': {
                borderBottom: 'none',
            },
            '& div div div div >.MuiDataGrid-cell:nth-of-type(1)': {
                borderBottom: 'none',
                paddingLeft: 0
            },
        },
        '& .invalid': {
            backgroundColor: '#b9d5ff91',
            color: '#1a3e72',
        }
    }
}));